import { commitMutation as commit } from "react-relay";
import environment from "../environment";

function commitMutation({ variables, file, mutation }) {
  return new Promise((resolve, reject) => {
    let uploadables;
    if (file) {
      uploadables = {
        imageFile: file.file[0],
      };
    }

    commit(environment, {
      mutation: mutation,
      variables,
      uploadables,
      onCompleted(response, errors) {
        if (errors) {
          reject(errors);
        }
        resolve(response);
      },
      onError(error) {
        reject(error);
      },
    });
  });
}

export default commitMutation;
